var exports = {
  "U": "xa15a2ab7--6c869b--arrow",
};

module.exports = exports;
